import { create } from 'zustand';
import api from 'services/api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  loading: true,

  checkAuth: async () => {
    if (window.location.hash?.includes('session_id=')) {
      set({ loading: false });
      return;
    }

    try {
      const response = await api.get('/auth/me');
      set({ user: response.data, loading: false });
    } catch {
      localStorage.removeItem('token');
      set({ user: null, token: null, loading: false });
    }
  },

  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    set({ token, user });
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await api.put('/auth/profile', { timezone: tz });
    } catch {}
    return user;
  },

  register: async (data) => {
    const response = await api.post('/auth/register', data);
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    set({ token, user });
    return user;
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (e) {
      console.error('Logout error:', e);
    }
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  updateUser: (userData) => set({ user: userData }),

  setAuth: (token, user) => {
    localStorage.setItem('token', token);
    set({ token, user });
  },
}));

export default useAuthStore;
